(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      console.log(this)
      console.log(this.cartDrawer)
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );
      this.submitButton.addEventListener(
        'click',
        this.onSubmitHandler.bind(this)       
      );
      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)       
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      const upsellItems = document.querySelectorAll(".product__grid__item product-upsell [data-product-radio]:checked");
      if(upsellItems && upsellItems.length>0){
        upsellItems.forEach((upsellItem, index)=>{
          const variantId = upsellItem.closest("product-upsell-item").querySelector("[data-variant-id]")?.value;
          formData.append(`items[${index}][id]`, variantId);
          formData.append(`items[${index}][quantity]`, '1');
        })
      }
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
          
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }

    toggleAddButton(disable, text, variant = null) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (!submitButton) return;
       
        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            this.#updateButtonContent(submitButton, text, null);
          }
        } else {
          submitButton.removeAttribute('disabled');
          const buttonText = this.hasAttribute('data-has-selling-plan')
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
          
          this.#updateButtonContent(submitButton, buttonText, variant);
        }
      });
    }

    #updateButtonContent(button, text, variant) {
      // Clear existing content but preserve button structure
      const existingPriceSpan = button.querySelector('.button__price');
      
      // Update the text content (first text node)
      const textNode = Array.from(button.childNodes).find(node => 
        node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      );
      
      if (textNode) {
        textNode.textContent = text;
      } else {
        // If no text node exists, create one
        button.insertBefore(document.createTextNode(text), button.firstChild);
      }

      // Handle price span
      if (variant && variant.available && variant.price !== undefined) {
        const formattedPrice = this.#formatPrice(variant.price);
        if (existingPriceSpan) {
          existingPriceSpan.textContent = ` - ${formattedPrice}`;
          existingPriceSpan.style.display = '';
        } else {
          // Create new price span
          const priceSpan = document.createElement('span');
          priceSpan.className = 'button__price';
          priceSpan.textContent = ` - ${formattedPrice}`;
          button.appendChild(priceSpan);
        }
      } else if (existingPriceSpan) {
        // Hide price span if variant is not available or no variant provided
        existingPriceSpan.style.display = 'none';
      }
    }

    #formatPrice(priceInCents) {
      // Use Shopify's formatMoney if available
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(priceInCents);
      }
      // Fallback formatting
      const price = priceInCents / 100;
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: `${window.Shopify.currency.active}`
      }).format(price);
    }
  }

  customElements.define('product-form', ProductForm);
})();
